import { useEffect } from "react";

import Switch from "@mui/material/Switch";

const ReadingSelection = ({ selectedTypes, setSelectedTypes }) => {
  const hideTranslation = selectedTypes.find(
    (item) => item.key === "reading"
  )?.hide_translation;

  const handleHideTranslationChange = (hideTranslation) => {
    setSelectedTypes((prev) => {
      return prev.map((item) => {
        if (item.key === "reading") {
          return { ...item, hide_translation: hideTranslation };
        }
        return item;
      });
    });
  };

  useEffect(() => {
    handleHideTranslationChange(true);
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        alignItems: "center",
      }}
    >
      <span>지문 읽기 해석 숨기기</span>
      <div>
        <Switch
          checked={hideTranslation}
          onChange={(event) =>
            handleHideTranslationChange(event.target.checked)
          }
          sx={{
            transform: "scale(1.2)", // Adjust the scale factor to resize the switch
          }}
        />
      </div>
    </div>
  );
};

export default ReadingSelection;
